import React from 'react';

interface ContentContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * ContentContainer - Wrapper pour le contenu avec padding interne
 * 
 * Ce composant fournit le padding interne pour le contenu des pages,
 * permettant au main-content d'être parfaitement collé à la sidebar
 * sans espace blanc, tout en gardant un espacement visuel approprié
 * pour le contenu.
 * 
 * Le padding est appliqué ICI, pas sur main-content, pour éviter
 * tout espace entre la sidebar et le contenu principal.
 */
export const ContentContainer: React.FC<ContentContainerProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`content-container app-page-container ${className}`}>
      {children}
    </div>
  );
};
